module.exports = __webpack_public_path__ + "static/media/divider.69fa735c.svg";